import { Link } from "react-router-dom";
import { ChevronRight, Flag } from "lucide-react";

// The original settings tab polls the authenticated result; this page creates no login session.
export default function SSOTestComplete() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-[var(--bg-color)] px-6 py-12">
      <section className="w-full max-w-md text-center" aria-labelledby="sso-test-complete-title">
        <div className="mx-auto flex size-[72px] items-center justify-center rounded-full border-[3px] border-[var(--color-success)] text-[var(--color-success)]">
          <Flag size={32} strokeWidth={2} aria-hidden="true" />
        </div>

        <h1
          id="sso-test-complete-title"
          className="mt-6 text-2xl font-semibold leading-tight text-[var(--text-color-primary)]"
        >
          SSO 测试认证已结束
        </h1>
        <p className="mx-auto mt-3 max-w-sm text-sm leading-6 text-[var(--text-color-secondary)]">
          请返回发起测试的 SSO 配置页面查看结果。测试通过后，请在原页面保存配置。
        </p>

        <div className="mx-auto mt-8 w-full max-w-xs overflow-hidden rounded-lg border border-[var(--border-color)] bg-[var(--bg-color)] shadow-sm">
          <button
            type="button"
            className="group relative flex h-14 w-full items-center justify-center px-12 text-[15px] text-[var(--text-color-regular)] transition-colors hover:bg-[var(--fill-color-lighter)] hover:text-[var(--text-color-primary)]"
            onClick={() => window.close()}
          >
            关闭此页面
            <ChevronRight
              className="absolute right-5 text-[var(--text-color-placeholder)] transition-transform group-hover:translate-x-0.5"
              size={18}
              aria-hidden="true"
            />
          </button>
          <Link
            className="group relative flex h-14 items-center justify-center border-t border-[var(--border-color-light)] px-12 text-[15px] text-[var(--text-color-regular)] transition-colors hover:bg-[var(--fill-color-lighter)] hover:text-[var(--text-color-primary)]"
            to="/iam/sso"
          >
            打开 SSO 配置页面
            <ChevronRight
              className="absolute right-5 text-[var(--text-color-placeholder)] transition-transform group-hover:translate-x-0.5"
              size={18}
              aria-hidden="true"
            />
          </Link>
        </div>
      </section>
    </main>
  );
}
